import { render, staticRenderFns } from "./CajaPaletaMtsIcon.vue?vue&type=template&id=77a1546e&"
import script from "./CajaPaletaMtsIcon.vue?vue&type=script&lang=js&"
export * from "./CajaPaletaMtsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBadge,VCard})
